var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 896v-90h86V316q0-24.75 17.625-42.375T226 256h620v60H226v490h234v90H80Zm479 0q-16.575 0-27.787-13.5Q520 869 520 852V415q0-16.575 11.213-27.787Q542.425 376 559 376h271.751Q850 376 865 386.5q15 10.5 15 28.5v437.273q0 18.584-14.5 31.155Q851 896 831 896H559Zm21-90h240V436H580v370Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.aca6329dc4273f045aeeb8eecf0c0b8f.svg";
export { ForwardRef as ReactComponent };